module.exports = __webpack_public_path__ + "static/media/home_back.8a8d2397.svg";